//*
// Do not edit directly
// Generated from Furry Design System
//

export const DewiRadiusRounded = '62.5rem'
export const DewiRadius2xl = '1.75rem'
export const DewiRadiusXl = '1.375rem'
export const DewiRadiusMd = '0.75rem'
export const DewiRadiusSm = '0.5rem'
export const DewiRadiusLg = '1rem'
export const DewiRadiusXs = '0.25rem'
export const DewiRadiusNone = '0'
export const DewiBreakpoints2xl = '1440'
export const DewiBreakpointsMd = '600'
export const DewiBreakpointsXs = '300'
export const DewiBreakpointsLg = '900'
export const DewiBreakpointsSm = '400'
export const DewiBreakpointsXl = '1300'
export const DewiSpacing0 = '0'
export const DewiSpacing1 = '0.25rem'
export const DewiSpacing2 = '0.5rem'
export const DewiSpacing3 = '0.75rem'
export const DewiSpacing4 = '1rem'
export const DewiSpacing5 = '1.25rem'
export const DewiSpacing6 = '1.5rem'
export const DewiSpacing7 = '1.75rem'
export const DewiSpacing8 = '2rem'
export const DewiSpacing9 = '2.25rem'
export const DewiSpacing10 = '2.5rem'
export const DewiSpacing11 = '2.75rem'
export const DewiSpacing12 = '3rem'
export const DewiSpacing14 = '3.5rem'
export const DewiSpacing16 = '4rem'
export const DewiSpacing20 = '5rem'
export const DewiSpacing24 = '6rem'
export const DewiSpacing28 = '7rem'
export const DewiSpacing30 = '7.5rem'
export const DewiSpacing32 = '8rem'
export const DewiSpacing36 = '9rem'
export const DewiSpacing40 = '10rem'
export const DewiSpacing48 = '12rem'
export const DewiSpacing52 = '13rem'
export const DewiSpacing56 = '14rem'
export const DewiSpacing60 = '15rem'
export const DewiSpacing64 = '16rem'
export const DewiSpacing72 = '18rem'
export const DewiSpacing80 = '20rem'
export const DewiSpacing96 = '24rem'
export const DewiSpacing25 = '0.625rem'
export const DewiSpacing025 = '0.0625rem'
export const DewiSpacing05 = '0.125rem'
export const DewiColorsStatesDestructiveActive = 'hsl(3, 75%, 63%)'
export const DewiColorsStatesDestructiveSelected = 'hsl(2, 78%, 68%)'
export const DewiColorsStatesDestructiveHover = 'hsl(2, 76%, 74%)'
export const DewiColorsStatesHighlight = 'hsl(39, 83%, 59%)'
export const DewiColorsStatesSuccess = 'hsl(117, 40%, 56%)'
export const DewiColorsStatesActive = 'hsl(214, 71%, 57%)'
export const DewiColorsStatesHover = 'hsl(212, 77%, 62%)'
export const DewiColorsStatesSelected = 'hsl(211, 83%, 67%)'
export const DewiColorsStatesFocus = 'hsl(211, 83%, 67%)'
export const DewiColorsYellow0 = 'hsl(51, 94%, 93%)'
export const DewiColorsYellow1 = 'hsl(49, 93%, 88%)'
export const DewiColorsYellow2 = 'hsl(50, 94%, 81%)'
export const DewiColorsYellow3 = 'hsl(48, 93%, 73%)'
export const DewiColorsYellow4 = 'hsl(47, 92%, 66%)'
export const DewiColorsYellow5 = 'hsl(44, 88%, 62%)'
export const DewiColorsYellow6 = 'hsl(39, 83%, 59%)'
export const DewiColorsYellow7 = 'hsl(36, 80%, 57%)'
export const DewiColorsYellow8 = 'hsl(32, 75%, 55%)'
export const DewiColorsYellow9 = 'hsl(28, 69%, 51%)'
export const DewiColorsViolet0 = 'hsl(249, 88%, 97%)'
export const DewiColorsViolet1 = 'hsl(255, 85%, 92%)'
export const DewiColorsViolet2 = 'hsl(253, 85%, 87%)'
export const DewiColorsViolet3 = 'hsl(254, 82%, 78%)'
export const DewiColorsViolet4 = 'hsl(254, 83%, 71%)'
export const DewiColorsViolet5 = 'hsl(253, 81%, 65%)'
export const DewiColorsViolet6 = 'hsl(253, 77%, 62%)'
export const DewiColorsViolet7 = 'hsl(253, 71%, 58%)'
export const DewiColorsViolet8 = 'hsl(253, 61%, 54%)'
export const DewiColorsViolet9 = 'hsl(253, 51%, 49%)'
export const DewiColorsTeal0 = 'hsl(159, 68%, 95%)'
export const DewiColorsTeal1 = 'hsl(159, 75%, 89%)'
export const DewiColorsTeal2 = 'hsl(159, 70%, 81%)'
export const DewiColorsTeal3 = 'hsl(157, 62%, 71%)'
export const DewiColorsTeal4 = 'hsl(156, 56%, 64%)'
export const DewiColorsTeal5 = 'hsl(154, 47%, 57%)'
export const DewiColorsTeal6 = 'hsl(153, 39%, 52%)'
export const DewiColorsTeal7 = 'hsl(152, 37%, 47%)'
export const DewiColorsTeal8 = 'hsl(152, 38%, 41%)'
export const DewiColorsTeal9 = 'hsl(152, 38%, 35%)'
export const DewiColorsRed0 = 'hsl(0, 67%, 98%)'
export const DewiColorsRed1 = 'hsl(3, 70%, 94%)'
export const DewiColorsRed2 = 'hsl(1, 74%, 88%)'
export const DewiColorsRed3 = 'hsl(2, 75%, 81%)'
export const DewiColorsRed4 = 'hsl(2, 76%, 74%)'
export const DewiColorsRed5 = 'hsl(2, 78%, 68%)'
export const DewiColorsRed6 = 'hsl(3, 75%, 63%)'
export const DewiColorsRed7 = 'hsl(3, 69%, 57%)'
export const DewiColorsRed8 = 'hsl(3, 60%, 52%)'
export const DewiColorsRed9 = 'hsl(3, 57%, 46%)'
export const DewiColorsPink0 = 'hsl(333, 65%, 97%)'
export const DewiColorsPink1 = 'hsl(336, 73%, 93%)'
export const DewiColorsPink2 = 'hsl(337, 66%, 86%)'
export const DewiColorsPink3 = 'hsl(338, 66%, 79%)'
export const DewiColorsPink4 = 'hsl(339, 67%, 72%)'
export const DewiColorsPink5 = 'hsl(340, 64%, 65%)'
export const DewiColorsPink6 = 'hsl(340, 60%, 58%)'
export const DewiColorsPink7 = 'hsl(341, 53%, 52%)'
export const DewiColorsPink8 = 'hsl(341, 54%, 45%)'
export const DewiColorsPink9 = 'hsl(342, 55%, 38%)'
export const DewiColorsOrange0 = 'hsl(35, 85%, 95%)'
export const DewiColorsOrange1 = 'hsl(35, 85%, 90%)'
export const DewiColorsOrange2 = 'hsl(34, 86%, 83%)'
export const DewiColorsOrange3 = 'hsl(34, 85%, 74%)'
export const DewiColorsOrange4 = 'hsl(32, 86%, 66%)'
export const DewiColorsOrange5 = 'hsl(29, 85%, 61%)'
export const DewiColorsOrange6 = 'hsl(26, 83%, 57%)'
export const DewiColorsOrange7 = 'hsl(22, 79%, 54%)'
export const DewiColorsOrange8 = 'hsl(19, 68%, 51%)'
export const DewiColorsOrange9 = 'hsl(16, 67%, 47%)'
export const DewiColorsLime0 = 'hsl(78, 79%, 94%)'
export const DewiColorsLime1 = 'hsl(78, 79%, 89%)'
export const DewiColorsLime2 = 'hsl(78, 77%, 81%)'
export const DewiColorsLime3 = 'hsl(79, 71%, 72%)'
export const DewiColorsLime4 = 'hsl(81, 68%, 64%)'
export const DewiColorsLime5 = 'hsl(83, 62%, 57%)'
export const DewiColorsLime6 = 'hsl(84, 54%, 52%)'
export const DewiColorsLime7 = 'hsl(85, 50%, 47%)'
export const DewiColorsLime8 = 'hsl(86, 52%, 43%)'
export const DewiColorsLime9 = 'hsl(85, 52%, 38%)'
export const DewiColorsIndigo0 = 'hsl(225, 89%, 96%)'
export const DewiColorsIndigo1 = 'hsl(227, 89%, 93%)'
export const DewiColorsIndigo2 = 'hsl(229, 89%, 86%)'
export const DewiColorsIndigo3 = 'hsl(230, 89%, 78%)'
export const DewiColorsIndigo4 = 'hsl(230, 86%, 72%)'
export const DewiColorsIndigo5 = 'hsl(230, 85%, 67%)'
export const DewiColorsIndigo6 = 'hsl(230, 81%, 63%)'
export const DewiColorsIndigo7 = 'hsl(230, 73%, 59%)'
export const DewiColorsIndigo8 = 'hsl(230, 62%, 54%)'
export const DewiColorsIndigo9 = 'hsl(231, 53%, 49%)'
export const DewiColorsGreen0 = 'hsl(125, 55%, 96%)'
export const DewiColorsGreen1 = 'hsl(122, 68%, 91%)'
export const DewiColorsGreen2 = 'hsl(121, 62%, 85%)'
export const DewiColorsGreen3 = 'hsl(119, 59%, 77%)'
export const DewiColorsGreen4 = 'hsl(119, 51%, 69%)'
export const DewiColorsGreen5 = 'hsl(118, 47%, 62%)'
export const DewiColorsGreen6 = 'hsl(117, 40%, 56%)'
export const DewiColorsGreen7 = 'hsl(117, 35%, 52%)'
export const DewiColorsGreen8 = 'hsl(118, 33%, 46%)'
export const DewiColorsGreen9 = 'hsl(119, 31%, 41%)'
export const DewiColorsGray0 = 'hsl(210, 17%, 98%)'
export const DewiColorsGray1 = 'hsl(210, 17%, 95%)'
export const DewiColorsGray2 = 'hsl(216, 14%, 93%)'
export const DewiColorsGray3 = 'hsl(214, 12%, 89%)'
export const DewiColorsGray4 = 'hsl(210, 12%, 83%)'
export const DewiColorsGray5 = 'hsl(210, 9%, 71%)'
export const DewiColorsGray6 = 'hsl(210, 6%, 56%)'
export const DewiColorsGray7 = 'hsl(210, 8%, 31%)'
export const DewiColorsGray8 = 'hsl(210, 9%, 23%)'
export const DewiColorsGray9 = 'hsl(214, 9%, 15%)'
export const DewiColorsGrape0 = 'hsl(278, 58%, 96%)'
export const DewiColorsGrape1 = 'hsl(282, 68%, 91%)'
export const DewiColorsGrape2 = 'hsl(282, 75%, 86%)'
export const DewiColorsGrape3 = 'hsl(284, 75%, 78%)'
export const DewiColorsGrape4 = 'hsl(284, 74%, 70%)'
export const DewiColorsGrape5 = 'hsl(283, 68%, 64%)'
export const DewiColorsGrape6 = 'hsl(283, 60%, 58%)'
export const DewiColorsGrape7 = 'hsl(284, 50%, 52%)'
export const DewiColorsGrape8 = 'hsl(284, 48%, 46%)'
export const DewiColorsGrape9 = 'hsl(284, 49%, 40%)'
export const DewiColorsDark0 = 'hsl(225, 3%, 76%)'
export const DewiColorsDark1 = 'hsl(228, 3%, 66%)'
export const DewiColorsDark2 = 'hsl(220, 3%, 58%)'
export const DewiColorsDark3 = 'hsl(225, 4%, 38%)'
export const DewiColorsDark4 = 'hsl(223, 6%, 23%)'
export const DewiColorsDark5 = 'hsl(223, 7%, 19%)'
export const DewiColorsDark6 = 'hsl(230, 8%, 16%)'
export const DewiColorsDark7 = 'hsl(225, 7%, 11%)'
export const DewiColorsDark8 = 'hsl(220, 7%, 8%)'
export const DewiColorsDark9 = 'hsl(220, 9%, 7%)'
export const DewiColorsCyan0 = 'hsl(186, 71%, 95%)'
export const DewiColorsCyan1 = 'hsl(186, 78%, 89%)'
export const DewiColorsCyan2 = 'hsl(188, 70%, 81%)'
export const DewiColorsCyan3 = 'hsl(189, 65%, 71%)'
export const DewiColorsCyan4 = 'hsl(190, 59%, 63%)'
export const DewiColorsCyan5 = 'hsl(192, 53%, 57%)'
export const DewiColorsCyan6 = 'hsl(192, 45%, 52%)'
export const DewiColorsCyan7 = 'hsl(192, 42%, 47%)'
export const DewiColorsCyan8 = 'hsl(193, 43%, 41%)'
export const DewiColorsCyan9 = 'hsl(194, 44%, 36%)'
export const DewiColorsBlue0 = 'hsl(207, 91%, 96%)'
export const DewiColorsBlue1 = 'hsl(209, 91%, 91%)'
export const DewiColorsBlue2 = 'hsl(209, 90%, 84%)'
export const DewiColorsBlue3 = 'hsl(210, 88%, 75%)'
export const DewiColorsBlue4 = 'hsl(211, 83%, 67%)'
export const DewiColorsBlue5 = 'hsl(212, 77%, 62%)'
export const DewiColorsBlue6 = 'hsl(214, 71%, 57%)'
export const DewiColorsBlue7 = 'hsl(214, 61%, 53%)'
export const DewiColorsBlue8 = 'hsl(214, 55%, 47%)'
export const DewiColorsBlue9 = 'hsl(214, 54%, 42%)'
export const DewiFontFamiliesInter = 'Inter'
export const DewiLineHeights0 = '1rem'
export const DewiLineHeights1 = '1.375rem'
export const DewiLineHeights2 = '1.5rem'
export const DewiLineHeights3 = '1.875rem'
export const DewiLineHeights4 = '2rem'
export const DewiLineHeights5 = '2.125rem'
export const DewiLineHeights6 = '2.625rem'
export const DewiLineHeights7 = '3rem'
export const DewiLineHeights8 = '3.625rem'
export const DewiLineHeights9 = '5.375rem'
export const DewiLineHeights10 = '6.75rem'
export const DewiLineHeights11 = '9rem'
export const DewiLineHeights12 = '12rem'
export const DewiFontSize0 = '0.75rem'
export const DewiFontSize1 = '0.875rem'
export const DewiFontSize2 = '1rem'
export const DewiFontSize3 = '1.125rem'
export const DewiFontSize4 = '1.25rem'
export const DewiFontSize5 = '1.5rem'
export const DewiFontSize6 = '1.875rem'
export const DewiFontSize7 = '2.25rem'
export const DewiFontSize8 = '3rem'
export const DewiFontSize9 = '3.75rem'
export const DewiFontSize10 = '4.5rem'
export const DewiFontSize11 = '6rem'
export const DewiFontSize12 = '8rem'
export const DewiLetterSpacing0 = '0'
export const DewiParagraphSpacing0 = '0'
